<template>
<div class="chapter">
<div class="inner_page">
<div>
<span class="image"><img alt="" src="images/18-W01-cover.jpg"/></span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 1A01Rowman.Series_cover.vue?5ff93438